// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=js"
// @generated from file vitesse/v1/program_index.proto (package vitesse.v1, syntax proto3)
/* eslint-disable */
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_vitesse_v1_entitlements } from "./entitlements_pb.js";
import { file_vitesse_v1_common } from "./common_pb.js";
import { file_vitesse_v1_program } from "./program_pb.js";
/**
 * Describes the file vitesse/v1/program_index.proto.
 */
export const file_vitesse_v1_program_index = /*@__PURE__*/ fileDesc("Ch52aXRlc3NlL3YxL3Byb2dyYW1faW5kZXgucHJvdG8SCnZpdGVzc2UudjEizgEKC0Jsb2NrQ3Vyc29yEjQKCWRpcmVjdGlvbhgBIAEoDjIhLnZpdGVzc2UudjEuQmxvY2tDdXJzb3IuRGlyZWN0aW9uEhkKEWFuY2hvcl9zb3J0X3ZhbHVlGAIgASgJEhcKD2FuY2hvcl9ibG9ja19pZBgDIAEoCSJVCglEaXJlY3Rpb24SGQoVRElSRUNUSU9OX1VOU1BFQ0lGSUVEEAASFQoRRElSRUNUSU9OX0ZPUldBUkQQARIWChJESVJFQ1RJT05fQkFDS1dBUkQQAiI+CgRTaXRlEhAKCGJsb2NrX2lkGAEgASgJEhIKCmJsb2NrX25hbWUYAiABKAkSEAoIbG9jYXRpb24YAyABKAkiSAoIQ2FsbEVkZ2USFAoMY2FsbGVyX2Jsb2NrGAEgASgJEhQKDGNhbGxlZV9ibG9jaxgCIAEoCRIQCghsb2NhdGlvbhgDIAEoCSJVCgpCbG9ja01hdGNoEhAKCGJsb2NrX2lkGAEgASgJEhIKCmJsb2NrX25hbWUYAiABKAkSEAoIbG9jYXRpb24YAyABKAkSDwoHc25pcHBldBgEIAEoCSKoAQoNQmxvY2tUcmVlTm9kZRIQCghibG9ja19pZBgBIAEoCRISCgpibG9ja190eXBlGAIgASgJEhQKDGJsb2NrX251bWJlchgDIAEoDRIMCgRuYW1lGAQgASgJEhAKCGxhbmd1YWdlGAUgASgJEhQKDGNvbXBpbGVfdGltZRgGIAEoCRIQCghzdF9ieXRlcxgHIAEoBBITCgtjaGlsZF9jb3VudBgIIAEoDSI1CglTeW1ib2xSZWYSFQoNY29udHJvbGxlcl9pZBgBIAEoCRIRCglzeW1ib2xfaWQYAiABKAkiMwoIQmxvY2tSZWYSFQoNY29udHJvbGxlcl9pZBgBIAEoCRIQCghibG9ja19pZBgCIAEoCSJICg5DYWxsR3JhcGhRdWVyeRIVCg1jb250cm9sbGVyX2lkGAEgASgJEhAKCGJsb2NrX2lkGAIgASgJEg0KBWRlcHRoGAMgASgNIkcKElByb2dyYW1TZWFyY2hRdWVyeRIVCg1jb250cm9sbGVyX2lkGAEgASgJEgsKA2Z0cxgCIAEoCRINCgVsaW1pdBgDIAEoDSIoCgVTaXRlcxIfCgVzaXRlcxgBIAMoCzIQLnZpdGVzc2UudjEuU2l0ZSJSCgpTaXRlc1JlcGx5EiIKBnJlc3VsdBgBIAEoCzISLnZpdGVzc2UudjEuUmVzdWx0EiAKBXNpdGVzGAIgASgLMhEudml0ZXNzZS52MS5TaXRlcyKEAQoOQ2FsbEdyYXBoUmVwbHkSIgoGcmVzdWx0GAEgASgLMhIudml0ZXNzZS52MS5SZXN1bHQSJgoIaW5jb21pbmcYAiADKAsyFC52aXRlc3NlLnYxLkNhbGxFZGdlEiYKCG91dGdvaW5nGAMgAygLMhQudml0ZXNzZS52MS5DYWxsRWRnZSJhChJTZWFyY2hQcm9ncmFtUmVwbHkSIgoGcmVzdWx0GAEgASgLMhIudml0ZXNzZS52MS5SZXN1bHQSJwoHbWF0Y2hlcxgCIAMoCzIWLnZpdGVzc2UudjEuQmxvY2tNYXRjaCK8AQoOQmxvY2tNZXRhUmVwbHkSIgoGcmVzdWx0GAEgASgLMhIudml0ZXNzZS52MS5SZXN1bHQSMQoFYmxvY2sYAiABKAsyIi52aXRlc3NlLnYxLlByb2dyYW1CbG9ja0Rlc2NyaXB0b3ISEgoKcmVhZF9jb3VudBgDIAEoDRITCgt3cml0ZV9jb3VudBgEIAEoDRIUCgxjYWxsZWVfY291bnQYBSABKA0SFAoMY2FsbGVyX2NvdW50GAYgASgNIt4BCg5CbG9ja1RyZWVRdWVyeRIVCg1jb250cm9sbGVyX2lkGAEgASgJEg4KBmZpbHRlchgCIAEoCRISCgpibG9ja190eXBlGAMgASgJEiwKC3BhZ2VfY3Vyc29yGAQgASgLMhcudml0ZXNzZS52MS5CbG9ja0N1cnNvchIRCglwYWdlX3NpemUYBSABKA0SEAoIZXhwYW5kZWQYBiADKAkSFwoPdmlld3BvcnRfYW5jaG9yGAcgASgJEhUKDXZpZXdwb3J0X3NpemUYCCABKA0SDgoGb2Zmc2V0GAkgASgNIigKD0dldFByb2dyYW1RdWVyeRIVCg1jb250cm9sbGVyX2lkGAEgASgJIqcCCglCbG9ja1BhZ2USFQoNY29udHJvbGxlcl9pZBgBIAEoCRIoCgVub2RlcxgCIAMoCzIZLnZpdGVzc2UudjEuQmxvY2tUcmVlTm9kZRIsCgtuZXh0X2N1cnNvchgDIAEoCzIXLnZpdGVzc2UudjEuQmxvY2tDdXJzb3ISLAoLcHJldl9jdXJzb3IYBCABKAsyFy52aXRlc3NlLnYxLkJsb2NrQ3Vyc29yEhYKDnRvdGFsX21hdGNoaW5nGAUgASgNEhYKDnRvdGFsX2luX3Njb3BlGAYgASgNEi4KB3Byb2dyYW0YByABKAsyHS52aXRlc3NlLnYxLlByb2dyYW1EZXNjcmlwdG9yEh0KFXNvdXJjZV9xdWVyeV9yZXZpc2lvbhgIIAEoBCJqChNHZXRCbG9ja1NvdXJjZVF1ZXJ5EhUKDWNvbnRyb2xsZXJfaWQYASABKAkSEAoIYmxvY2tfaWQYAiABKAkSKgoEa2luZBgDIAEoDjIcLnZpdGVzc2UudjEuUHJvZ3JhbUJsb2NrS2luZCJnCgtTb3VyY2VGcmFtZRI2CgpkZXNjcmlwdG9yGAEgASgLMiIudml0ZXNzZS52MS5Qcm9ncmFtQmxvY2tEZXNjcmlwdG9yEgwKBGRhdGEYAiABKAwSEgoKc2hhMjU2X2hleBgDIAEoCSK3AgoTUHJvZ3JhbVF1ZXJ5UmVxdWVzdBIOCgZvcmdfaWQYASABKAkSEgoKZ2F0ZXdheV9pZBgCIAEoCRIrCgp3aG9fd3JpdGVzGAMgASgLMhUudml0ZXNzZS52MS5TeW1ib2xSZWZIABIqCgl3aG9fcmVhZHMYBCABKAsyFS52aXRlc3NlLnYxLlN5bWJvbFJlZkgAEjAKCmNhbGxfZ3JhcGgYBSABKAsyGi52aXRlc3NlLnYxLkNhbGxHcmFwaFF1ZXJ5SAASOAoOc2VhcmNoX3Byb2dyYW0YBiABKAsyHi52aXRlc3NlLnYxLlByb2dyYW1TZWFyY2hRdWVyeUgAEi4KDmJsb2NrX21ldGFkYXRhGAcgASgLMhQudml0ZXNzZS52MS5CbG9ja1JlZkgAQgcKBXF1ZXJ5IogCChFQcm9ncmFtUXVlcnlSZXBseRIiCgZyZXN1bHQYASABKAsyEi52aXRlc3NlLnYxLlJlc3VsdBIiCgVzaXRlcxgCIAEoCzIRLnZpdGVzc2UudjEuU2l0ZXNIABIwCgpjYWxsX2dyYXBoGAMgASgLMhoudml0ZXNzZS52MS5DYWxsR3JhcGhSZXBseUgAEjgKDnNlYXJjaF9wcm9ncmFtGAQgASgLMh4udml0ZXNzZS52MS5TZWFyY2hQcm9ncmFtUmVwbHlIABI0Cg5ibG9ja19tZXRhZGF0YRgFIAEoCzIaLnZpdGVzc2UudjEuQmxvY2tNZXRhUmVwbHlIAEIJCgdwYXlsb2FkIpkCChxQcm9ncmFtSW5kZXhTdWJzY3JpYmVSZXF1ZXN0EhIKCnNlc3Npb25faWQYASABKAkSDgoGb3JnX2lkGAIgASgJEhIKCmdhdGV3YXlfaWQYAyABKAkSFQoNcmVwbHlfc3ViamVjdBgEIAEoCRIwCgpibG9ja190cmVlGAUgASgLMhoudml0ZXNzZS52MS5CbG9ja1RyZWVRdWVyeUgAEjIKC2dldF9wcm9ncmFtGAYgASgLMhsudml0ZXNzZS52MS5HZXRQcm9ncmFtUXVlcnlIABI7ChBnZXRfYmxvY2tfc291cmNlGAcgASgLMh8udml0ZXNzZS52MS5HZXRCbG9ja1NvdXJjZVF1ZXJ5SABCBwoFcXVlcnkipwEKGlByb2dyYW1JbmRleFN1YnNjcmliZVJlcGx5EiIKBnJlc3VsdBgBIAEoCzISLnZpdGVzc2UudjEuUmVzdWx0EisKCmZpcnN0X3BhZ2UYAiABKAsyFS52aXRlc3NlLnYxLkJsb2NrUGFnZUgAEi8KDGZpcnN0X3NvdXJjZRgDIAEoCzIXLnZpdGVzc2UudjEuU291cmNlRnJhbWVIAEIHCgVmaXJzdCI0Ch5Qcm9ncmFtSW5kZXhVbnN1YnNjcmliZVJlcXVlc3QSEgoKc2Vzc2lvbl9pZBgBIAEoCSqNAQoQUHJvZ3JhbUJsb2NrS2luZBIiCh5QUk9HUkFNX0JMT0NLX0tJTkRfVU5TUEVDSUZJRUQQABIZChVQUk9HUkFNX0JMT0NLX0tJTkRfU1QQARIaChZQUk9HUkFNX0JMT0NLX0tJTkRfWE1MEAISHgoaUFJPR1JBTV9CTE9DS19LSU5EX1NJREVDQVIQAzKCBQoMUHJvZ3JhbUluZGV4EkQKCVdob1dyaXRlcxIVLnZpdGVzc2UudjEuU3ltYm9sUmVmGhYudml0ZXNzZS52MS5TaXRlc1JlcGx5IgiKtRgEEARAbhJDCghXaG9SZWFkcxIVLnZpdGVzc2UudjEuU3ltYm9sUmVmGhYudml0ZXNzZS52MS5TaXRlc1JlcGx5IgiKtRgEEARAbhJNCglDYWxsR3JhcGgSGi52aXRlc3NlLnYxLkNhbGxHcmFwaFF1ZXJ5Ghoudml0ZXNzZS52MS5DYWxsR3JhcGhSZXBseSIIirUYBBAEQG4SWQoNU2VhcmNoUHJvZ3JhbRIeLnZpdGVzc2UudjEuUHJvZ3JhbVNlYXJjaFF1ZXJ5Gh4udml0ZXNzZS52MS5TZWFyY2hQcm9ncmFtUmVwbHkiCIq1GAQQBEBuEksKDUJsb2NrTWV0YWRhdGESFC52aXRlc3NlLnYxLkJsb2NrUmVmGhoudml0ZXNzZS52MS5CbG9ja01ldGFSZXBseSIIirUYBBAEQG4SSgoJQmxvY2tUcmVlEhoudml0ZXNzZS52MS5CbG9ja1RyZWVRdWVyeRoVLnZpdGVzc2UudjEuQmxvY2tQYWdlIgiKtRgEEARAbjABEkwKCkdldFByb2dyYW0SGy52aXRlc3NlLnYxLkdldFByb2dyYW1RdWVyeRoVLnZpdGVzc2UudjEuQmxvY2tQYWdlIgiKtRgEEARAbjABElYKDkdldEJsb2NrU291cmNlEh8udml0ZXNzZS52MS5HZXRCbG9ja1NvdXJjZVF1ZXJ5Ghcudml0ZXNzZS52MS5Tb3VyY2VGcmFtZSIIirUYBBAEQHAwAUK2AQoOY29tLnZpdGVzc2UudjFCEVByb2dyYW1JbmRleFByb3RvUAFaSGdpdGh1Yi5jb20vTW92ZW5kaS1haS92aXRlc3NlLXBsYXRmb3JtL3Byb3RvL2dlbi9nby92aXRlc3NlL3YxO3ZpdGVzc2V2MaICA1ZYWKoCClZpdGVzc2UuVjHKAgpWaXRlc3NlXFYx4gIWVml0ZXNzZVxWMVxHUEJNZXRhZGF0YeoCC1ZpdGVzc2U6OlYxYgZwcm90bzM", [file_vitesse_v1_entitlements, file_vitesse_v1_common, file_vitesse_v1_program]);
/**
 * Describes the message vitesse.v1.BlockCursor.
 * Use `create(BlockCursorSchema)` to create a new message.
 */
export const BlockCursorSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_program_index, 0);
/**
 * @generated from enum vitesse.v1.BlockCursor.Direction
 */
export var BlockCursor_Direction;
(function (BlockCursor_Direction) {
    /**
     * forward (next page)
     *
     * @generated from enum value: DIRECTION_UNSPECIFIED = 0;
     */
    BlockCursor_Direction[BlockCursor_Direction["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: DIRECTION_FORWARD = 1;
     */
    BlockCursor_Direction[BlockCursor_Direction["FORWARD"] = 1] = "FORWARD";
    /**
     * @generated from enum value: DIRECTION_BACKWARD = 2;
     */
    BlockCursor_Direction[BlockCursor_Direction["BACKWARD"] = 2] = "BACKWARD";
})(BlockCursor_Direction || (BlockCursor_Direction = {}));
/**
 * Describes the enum vitesse.v1.BlockCursor.Direction.
 */
export const BlockCursor_DirectionSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_program_index, 0, 0);
/**
 * Describes the message vitesse.v1.Site.
 * Use `create(SiteSchema)` to create a new message.
 */
export const SiteSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_program_index, 1);
/**
 * Describes the message vitesse.v1.CallEdge.
 * Use `create(CallEdgeSchema)` to create a new message.
 */
export const CallEdgeSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_program_index, 2);
/**
 * Describes the message vitesse.v1.BlockMatch.
 * Use `create(BlockMatchSchema)` to create a new message.
 */
export const BlockMatchSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_program_index, 3);
/**
 * Describes the message vitesse.v1.BlockTreeNode.
 * Use `create(BlockTreeNodeSchema)` to create a new message.
 */
export const BlockTreeNodeSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_program_index, 4);
/**
 * Describes the message vitesse.v1.SymbolRef.
 * Use `create(SymbolRefSchema)` to create a new message.
 */
export const SymbolRefSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_program_index, 5);
/**
 * Describes the message vitesse.v1.BlockRef.
 * Use `create(BlockRefSchema)` to create a new message.
 */
export const BlockRefSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_program_index, 6);
/**
 * Describes the message vitesse.v1.CallGraphQuery.
 * Use `create(CallGraphQuerySchema)` to create a new message.
 */
export const CallGraphQuerySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_program_index, 7);
/**
 * Describes the message vitesse.v1.ProgramSearchQuery.
 * Use `create(ProgramSearchQuerySchema)` to create a new message.
 */
export const ProgramSearchQuerySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_program_index, 8);
/**
 * Describes the message vitesse.v1.Sites.
 * Use `create(SitesSchema)` to create a new message.
 */
export const SitesSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_program_index, 9);
/**
 * Describes the message vitesse.v1.SitesReply.
 * Use `create(SitesReplySchema)` to create a new message.
 */
export const SitesReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_program_index, 10);
/**
 * Describes the message vitesse.v1.CallGraphReply.
 * Use `create(CallGraphReplySchema)` to create a new message.
 */
export const CallGraphReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_program_index, 11);
/**
 * Describes the message vitesse.v1.SearchProgramReply.
 * Use `create(SearchProgramReplySchema)` to create a new message.
 */
export const SearchProgramReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_program_index, 12);
/**
 * Describes the message vitesse.v1.BlockMetaReply.
 * Use `create(BlockMetaReplySchema)` to create a new message.
 */
export const BlockMetaReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_program_index, 13);
/**
 * Describes the message vitesse.v1.BlockTreeQuery.
 * Use `create(BlockTreeQuerySchema)` to create a new message.
 */
export const BlockTreeQuerySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_program_index, 14);
/**
 * Describes the message vitesse.v1.GetProgramQuery.
 * Use `create(GetProgramQuerySchema)` to create a new message.
 */
export const GetProgramQuerySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_program_index, 15);
/**
 * Describes the message vitesse.v1.BlockPage.
 * Use `create(BlockPageSchema)` to create a new message.
 */
export const BlockPageSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_program_index, 16);
/**
 * Describes the message vitesse.v1.GetBlockSourceQuery.
 * Use `create(GetBlockSourceQuerySchema)` to create a new message.
 */
export const GetBlockSourceQuerySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_program_index, 17);
/**
 * Describes the message vitesse.v1.SourceFrame.
 * Use `create(SourceFrameSchema)` to create a new message.
 */
export const SourceFrameSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_program_index, 18);
/**
 * Describes the message vitesse.v1.ProgramQueryRequest.
 * Use `create(ProgramQueryRequestSchema)` to create a new message.
 */
export const ProgramQueryRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_program_index, 19);
/**
 * Describes the message vitesse.v1.ProgramQueryReply.
 * Use `create(ProgramQueryReplySchema)` to create a new message.
 */
export const ProgramQueryReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_program_index, 20);
/**
 * Describes the message vitesse.v1.ProgramIndexSubscribeRequest.
 * Use `create(ProgramIndexSubscribeRequestSchema)` to create a new message.
 */
export const ProgramIndexSubscribeRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_program_index, 21);
/**
 * Describes the message vitesse.v1.ProgramIndexSubscribeReply.
 * Use `create(ProgramIndexSubscribeReplySchema)` to create a new message.
 */
export const ProgramIndexSubscribeReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_program_index, 22);
/**
 * Describes the message vitesse.v1.ProgramIndexUnsubscribeRequest.
 * Use `create(ProgramIndexUnsubscribeRequestSchema)` to create a new message.
 */
export const ProgramIndexUnsubscribeRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_program_index, 23);
/**
 * Which blob kind GetBlockSource streams. The ObjectStore blobs are gzip-framed
 * per the wire contract; api-gateway gunzips before sending so the client gets
 * ready-to-render bytes.
 *
 * @generated from enum vitesse.v1.ProgramBlockKind
 */
export var ProgramBlockKind;
(function (ProgramBlockKind) {
    /**
     * @generated from enum value: PROGRAM_BLOCK_KIND_UNSPECIFIED = 0;
     */
    ProgramBlockKind[ProgramBlockKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * IEC 61131-3 Structured Text source
     *
     * @generated from enum value: PROGRAM_BLOCK_KIND_ST = 1;
     */
    ProgramBlockKind[ProgramBlockKind["ST"] = 1] = "ST";
    /**
     * raw vendor XML (TIA, Control Expert)
     *
     * @generated from enum value: PROGRAM_BLOCK_KIND_XML = 2;
     */
    ProgramBlockKind[ProgramBlockKind["XML"] = 2] = "XML";
    /**
     * JSON sidecar (xrefs, callees, per-network metadata)
     *
     * @generated from enum value: PROGRAM_BLOCK_KIND_SIDECAR = 3;
     */
    ProgramBlockKind[ProgramBlockKind["SIDECAR"] = 3] = "SIDECAR";
})(ProgramBlockKind || (ProgramBlockKind = {}));
/**
 * Describes the enum vitesse.v1.ProgramBlockKind.
 */
export const ProgramBlockKindSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_program_index, 0);
/**
 * ─── the browser-facing service ──────────────────────────────────────────────
 * Exposed via api-gateway. Unary RPCs bridge to cmd.program-indexer.query
 * (request/reply); streaming RPCs bridge to the cmd.program-indexer.subscribe +
 * per-session reply-subject pattern. Clerk JWT + org-scoping are api-gateway's
 * concern — the program-indexer never sees HTTP, Connect, or Clerk.
 *
 * @generated from service vitesse.v1.ProgramIndex
 */
export const ProgramIndex = /*@__PURE__*/ serviceDesc(file_vitesse_v1_program_index, 0);
//# sourceMappingURL=program_index_pb.js.map